import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfirmTokenService } from '../../../services/confirm-token/confirm-token.service';
import { BigIconTextComponent } from '../../../shared/components/big-icon-text/big-icon-text.component';

import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';

@Component({
  selector: 'pt-portal-registerconfirm',
  templateUrl: './registerconfirm.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BigIconTextComponent, RouterLink, Bind, Button],
})
export class RegisterconfirmComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private confirmTokenService = inject(ConfirmTokenService);

  status: boolean;

  constructor() {
    this.status = undefined;
  }

  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');
    this.confirmTokenService.confirmToken(token).subscribe(
      () => {
        this.status = true;
      },
      () => {
        this.status = false;
      },
    );
  }
}
